import dayjs from 'dayjs';
import useVuelidate from '@vuelidate/core';
import { required } from '@/utils/validators';

import { PRICE_PER_MEMBER } from '@/utils/constants';

export default {
  name: 'Checkout',
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      pricePerMember: PRICE_PER_MEMBER,
      fields: [
        {
          key: 'companyName',
          label: '公司名稱',
          required: true,
        },
        {
          key: 'companyAddress',
          label: '公司地址',
          required: true,
        },
        {
          key: 'companyPhone',
          label: '公司電話',
          required: true,
        },
        {
          key: 'companyTaxId',
          label: '統一編號',
          required: false,
        },
        {
          key: 'contactName',
          label: '聯絡人姓名',
          required: true,
        },
        {
          key: 'contactPhone',
          label: '聯絡人電話',
          required: true,
        },
        {
          key: 'contactEmail',
          label: '聯絡人 Email',
          required: true,
        },
      ],
      termsAgreed: false,
      form: {
        companyName: '',
        companyAddress: '',
        companyPhone: '',
        companyTaxId: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
      },
    };
  },
  computed: {
    nextPaymentDate() {
      return dayjs().add(1, 'month').endOf('month').format('YYYY/MM/DD');
    },
    upgradingUnavailable() {
      return !this.termsAgreed || this.v$.$invalid;
    },
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.form);
    },
  },
  validations() {
    return {
      form: {
        companyName: {
          required: required('公司名稱'),
        },
        companyAddress: {
          required: required('公司地址'),
        },
        companyPhone: {
          required: required('公司電話'),
        },
        contactName: {
          required: required('聯絡人姓名'),
        },
        contactPhone: {
          required: required('聯絡人電話'),
        },
        contactEmail: {
          required: required('聯絡人 Email'),
        },
      },
    };
  },
};
